angular.module('Itao.IndicatorMap').directive('detailedLegend', ['UtilityService', 'mapConfig', '$timeout', function (UtilityService, mapConfig, $timeout) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'detailedLegend.html',
    restrict: 'E',
    replace: true,
    scope: {
      clickable: '=',
      type: '=',
      disabledListIndex: '=?',
      noDataDistricts: '=?',
      disabledDistrictKeys: '=',
      disabledYears: '=',
      years: '=',
      colorSets: '=',
      selectedDataLayer: '=',
      selectedIndicator: '=',
      mouseOverFeature: '=?',
      mouseOverDistrict: '=?',
      mouseOverProperty: '=?',
      mouseOverYear: '=?',
      highlightTwin: '=?',
    },
    link: function (scope) {
      var availableDistricts = [];
      var timer;

      /**
       * sets legend with given config
       */
      var setLegend = function () {
        if (!scope.selectedDataLayer || !scope.selectedIndicator || !scope.selectedDataLayer.legend || !scope.selectedDataLayer.legend[scope.selectedIndicator.uid] || !scope.selectedDataLayer.legend[scope.selectedIndicator.uid][scope.type]) {
          scope.legend = {};
          scope.showHighlightLine = false;
        } else {
          scope.legend = scope.selectedDataLayer.legend[scope.selectedIndicator.uid][scope.type];
          scope.showHighlightLine = (scope.legend.redLines && scope.legend.redLines.length > 0) || mapConfig.redLines.length > 0;

          angular.forEach(scope.colorSets, function (colorSet) {
            if (colorSet.uid == scope.legend.colorSet) {
              scope.selectedColorSet = colorSet;
            }
          });

          scope.disabledListIndex = scope.disabledListIndex && scope.disabledListIndex.length ? scope.disabledListIndex : [];
          if (!scope.clickable && scope.legend.scales) {
            scope.legend.scales.forEach(function (scale, index) {
              if (scale.radio && index > 0) {
                scope.disabledListIndex.push(index);
              } else if (scope.legend.yearlyLegend && scope.years && scope.mouseOverProperty !== 'index') {
                scale.year = scope.years[index - 1]; // index-1 when using area-chart (leave out first legend-item) - check for new yearly-line-chart
              }
            });
          }

          if (scope.legend.districtLegend) {
            var districtUid;
            for (districtUid in scope.selectedDataLayer.districts) {
              availableDistricts.push(scope.selectedDataLayer.districts[districtUid].key);
            }
          }
        }
      };

      /**
       * set mouse-over for district
       * @param district
       */
      scope.setMouseOverDistrict = function (district) {
        if (district === undefined) return;
        if (district) {
          scope.mouseOverDistrict = district;
        } else {
          scope.mouseOverDistrict = null;
        }
      };

      /**
       * set mouse-over for index
       * @param scale
       * @param idx
       */
      scope.setMouseOver = function (scale, idx) {
        if (scale === undefined) {
          scope.mouseOverFeature = null;
          if (timer) {
            $timeout.cancel(timer);
            timer = undefined;
          }
        } else if (scale.district) {
          scope.mouseOverFeature = scale.district;
        } else if (scope.mouseOverProperty && scope.mouseOverProperty === 'index') {
          timer = $timeout(function () {
            scope.mouseOverFeature = idx;
          }, 250);
        } else if (scale.year) {
          scope.mouseOverFeature = scale.year;
        }
      };

      scope.legend = undefined;

      scope.disabledListIndex = scope.disabledListIndex ? scope.disabledListIndex : [];
      scope.$watch('selectedDataLayer', function () {
        setLegend();
      });
      scope.$watch('selectedIndicator', function () {
        setLegend();
      });
      scope.$watch('disabledYears', function () {
        setLegend();
      });

      scope.disabledDistrictScale = function (districtKey) {
        return scope.disabledDistrictKeys && (scope.disabledDistrictKeys.indexOf(districtKey) > -1 || scope.noDataDistricts.indexOf(districtKey) > -1 || availableDistricts.indexOf(districtKey) === -1);
      };

      scope.showHighlightLine = mapConfig.redLines.length > 0;

      scope.iconSvg = function (scale, color) {
        var tempScale = angular.copy(scale);
        tempScale.color = color;
        if (!scale.icon) return '';
        return UtilityService.iconSvg(tempScale);
      };

      // for print-style to add !importand and prevent converting to rgb()
      scope.ngAttrScaleColor = function (color) {
        return 'background-color: ' + color + ' !important';
      };

      scope.disableIndex = function (index, reverse) {
        if (reverse) {
          scope.disabledListIndex = [];
          angular.forEach(scope.legend.scales, function (scale, scaleIndex) {
            if (scale.radio && index !== scaleIndex) {
              scope.disabledListIndex.push(scaleIndex);
            }
          });
        } else {
          if (scope.disabledListIndex.indexOf(index) === -1) {
            scope.disabledListIndex.push(index);
          } else {
            scope.disabledListIndex.splice(scope.disabledListIndex.indexOf(index), 1);
          }
        }
      };

      scope.$watchCollection('noDataDistricts', setLegend);
    }
  };
}]);
